/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import {PromotionsTypeEnum} from "../../../data/mypuratos";
import {BundleDetailColumn} from "../../molecules/products/BundleDetailsColumns";
import RelatedProductRow from "./RelatedProductRow";
import * as React from "react";
import {withI18N} from "../../hoc/withI18N";
import {FlexRow} from "../../atoms/layout/FlexRow";
import Block from "../../atoms/layout/Block";
import {GTMContext} from "../../../analytics/ga4/utils/GTMContext";
import {connect} from "react-redux";
import {addBundleToCart} from "../../../actions/cart";


class ModalBundleRow extends React.Component {

    static contextType = GTMContext;

    state = {
        quantity: 1,
        response: false,
        showDetails: true,
    };

    componentDidMount() {
        if (this.props.sku) {
            this.setState({ quantity: 1 });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.sku !== this.props.sku) {
            this.setState({ quantity: 1 });
        }
    }

    updateQuantity = quantity => this.setState( { quantity });

    orderProduct = () => {
        this.setState( { response: false });
        this.props.addBundleToCart({
            bundle: this.props.bundle,
            quantity: this.state.quantity,
            type: this.context,
            callback: () => {
                this.setState( { quantity: 1, response: true });
            }
        });
    };

    toggleBundleDetails = () => this.setState({showDetails: !this.state.showDetails});

    render() {
        const { promotion, bundle, isBundleLoading, translate, addEvent, position } = this.props;
        const { showDetails } = this.state;

        return <div
            className={"ordering-modal__product-row promoted" + (promotion?.type === PromotionsTypeEnum.OPTIONAL_BUNDLES ? " p-padding-top-md" : "")}>
            <Block className={"row p-flex p-flex-wrap ordering-modal__product-row"} style={FlexRow.styles.center}>
                <div className="p-flex p-flex-column col-sm-5 col-xs-12">
                    <h6 className={"p-sans p-margin-top-none p-margin-bottom-xs"}>
                        {translate("Bundle")}: {bundle?.bundleName}
                    </h6>
                    <a className={"p-bundle-row__show-hide p-margin-bottom-xs"} onClick={this.toggleBundleDetails}>
                        {showDetails ? translate("Collapse details") : translate("Expand details")}
                        <span className={showDetails ? "open" : "closed"}/>
                    </a>
                </div>
                <div className={"row p-flex p-flex-wrap p-flex-align-center p-flex-justify-content-end col-xs-12 col-sm-7 p-padding-none p-margin-none"}>
                    <BundleDetailColumn bundle={bundle}
                                        isLoading={isBundleLoading}
                                        response={this.state.response}
                                        updateQuantity={this.updateQuantity}
                                        quantity={this.state.quantity}
                                        addToCart={this.orderProduct} />
                </div>
            </Block>
            {showDetails && <div className="p-margin-top-sm">
                {bundle?.items.map((item) =>
                    <RelatedProductRow key={item.materialNumber} product={item} quantity={item.quantity} addEvent={addEvent} position={position} modal/>)}
            </div>}
        </div>
    }

}

const mapActionsToProps = {
    addBundleToCart
};

export default withI18N(connect(undefined, mapActionsToProps)(ModalBundleRow));
